// Color tokens for shift templates / shift blocks. Keep keys in sync with
// backend `SHIFT_COLORS` in /app/backend/routers/schedule.py.

export const SHIFT_COLORS = [
  { key: "indigo", label: "Indigó", chip: "bg-indigo-500" },
  { key: "emerald", label: "Smaragd", chip: "bg-emerald-500" },
  { key: "amber", label: "Borostyán", chip: "bg-amber-500" },
  { key: "rose", label: "Rózsa", chip: "bg-rose-500" },
  { key: "sky", label: "Égszín", chip: "bg-sky-500" },
  { key: "violet", label: "Lila", chip: "bg-violet-500" },
  { key: "teal", label: "Türkiz", chip: "bg-teal-500" },
  { key: "fuchsia", label: "Fukszia", chip: "bg-fuchsia-500" },
  { key: "orange", label: "Narancs", chip: "bg-orange-500" },
  { key: "slate", label: "Szürke", chip: "bg-slate-500" },
];

// Map "color key" -> tailwind class set used by shift blocks / template pills.
export const COLOR_STYLES = {
  indigo: {
    block: "bg-indigo-50 border-indigo-300 text-indigo-900 dark:bg-indigo-500/10 dark:border-indigo-500/40 dark:text-indigo-200",
    pill: "from-indigo-500 to-indigo-700",
    dot: "bg-indigo-500",
    ring: "ring-indigo-300",
  },
  emerald: {
    block: "bg-emerald-50 border-emerald-300 text-emerald-900 dark:bg-emerald-500/10 dark:border-emerald-500/40 dark:text-emerald-200",
    pill: "from-emerald-500 to-emerald-700",
    dot: "bg-emerald-500",
    ring: "ring-emerald-300",
  },
  amber: {
    block: "bg-amber-50 border-amber-300 text-amber-900 dark:bg-amber-500/10 dark:border-amber-500/40 dark:text-amber-200",
    pill: "from-amber-500 to-amber-700",
    dot: "bg-amber-500",
    ring: "ring-amber-300",
  },
  rose: {
    block: "bg-rose-50 border-rose-300 text-rose-900 dark:bg-rose-500/10 dark:border-rose-500/40 dark:text-rose-200",
    pill: "from-rose-500 to-rose-700",
    dot: "bg-rose-500",
    ring: "ring-rose-300",
  },
  sky: {
    block: "bg-sky-50 border-sky-300 text-sky-900 dark:bg-sky-500/10 dark:border-sky-500/40 dark:text-sky-200",
    pill: "from-sky-500 to-sky-700",
    dot: "bg-sky-500",
    ring: "ring-sky-300",
  },
  violet: {
    block: "bg-violet-50 border-violet-300 text-violet-900 dark:bg-violet-500/10 dark:border-violet-500/40 dark:text-violet-200",
    pill: "from-violet-500 to-violet-700",
    dot: "bg-violet-500",
    ring: "ring-violet-300",
  },
  teal: {
    block: "bg-teal-50 border-teal-300 text-teal-900 dark:bg-teal-500/10 dark:border-teal-500/40 dark:text-teal-200",
    pill: "from-teal-500 to-teal-700",
    dot: "bg-teal-500",
    ring: "ring-teal-300",
  },
  fuchsia: {
    block: "bg-fuchsia-50 border-fuchsia-300 text-fuchsia-900 dark:bg-fuchsia-500/10 dark:border-fuchsia-500/40 dark:text-fuchsia-200",
    pill: "from-fuchsia-500 to-fuchsia-700",
    dot: "bg-fuchsia-500",
    ring: "ring-fuchsia-300",
  },
  orange: {
    block: "bg-orange-50 border-orange-300 text-orange-900 dark:bg-orange-500/10 dark:border-orange-500/40 dark:text-orange-200",
    pill: "from-orange-500 to-orange-700",
    dot: "bg-orange-500",
    ring: "ring-orange-300",
  },
  slate: {
    block: "bg-slate-100 border-slate-300 text-slate-900 dark:bg-slate-500/15 dark:border-slate-500/40 dark:text-slate-200",
    pill: "from-slate-500 to-slate-700",
    dot: "bg-slate-500",
    ring: "ring-slate-300",
  },
};

export const colorStyles = (key) => COLOR_STYLES[key] || COLOR_STYLES.indigo;

export const HU_DAY_LABELS = [
  { short: "H", long: "Hétfő" },
  { short: "K", long: "Kedd" },
  { short: "Sze", long: "Szerda" },
  { short: "Cs", long: "Csütörtök" },
  { short: "P", long: "Péntek" },
  { short: "Szo", long: "Szombat" },
  { short: "V", long: "Vasárnap" },
];

export function isoMonday(date = new Date()) {
  const d = new Date(date);
  const dow = (d.getDay() + 6) % 7; // 0=Mon
  d.setDate(d.getDate() - dow);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function isoString(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function formatDayHu(iso) {
  const d = new Date(iso + "T00:00:00");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${month}. ${day}`;
}

export function fmtHours(n) {
  const v = Number(n) || 0;
  // 24.5 -> "24,5"; integer -> no decimal
  return Number.isInteger(v) ? `${v}` : v.toFixed(1).replace(".", ",");
}
